import React from 'react';
import Button from '@mui/material/Button';

import ErrorPage, { SupportLink } from 'src/components/errors/ErrorPage';
import styles from 'src/components/errors/ErrorPage.module.css';
import shark503 from 'src/assets/img/errors/shark-503.webp';

type Props = {
    onRetry: () => void;
};

export default function ApiUnreachablePage({ onRetry }: Props) {
    return (
        <ErrorPage
            fullPage
            image={shark503}
            title="We can't reach Reffie right now"
            message={<>Our servers aren&apos;t responding. This is usually temporary. Try again in a moment, or contact <SupportLink /> if it keeps happening.</>}
        >
            <div className={styles.actions}>
                <Button variant="contained" size="large" onClick={onRetry} data-testid="api-unreachable-retry-button">
                    Try again
                </Button>
            </div>
        </ErrorPage>
    );
}
